import { Select as AntdSelect, Collapse, Divider, Input, Row } from 'antd'
import Flex from 'components/Flex'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'

export const OuterDiv = styled.div`
  background: white;
  border-radius: 10px;
  border: 1px solid #bbbbbb;
`
export const OuterPadding = styled.div`
  padding: 15px;
`
export const CustomDiver = styled(Divider)`
  margin: 0px 0;
`

export const HeadingFlex = styled(Flex)`
  width: 100%;
  height: 40px;
  background: #dfdaf4;
  border-radius: 5px;
  justify-content: center;
  align-items: center;
`
export const Footer = styled.div`
  position: absolute;

  width: 100%;

  padding: 10px 16px;
  background: #fff;
  text-align: right;
`

export const TitleText = styled.div`
  font-family: Plus Jakarta Sans;
  font-size: 12px;
  font-weight: 400;
  line-height: 11px;
  color: #4b465c;
  span {
    font-weight: 600 !important;
  }
`

export const BoxFlex = styled(Flex)`
  gap: 15px;
`

export const SkilsBox = styled.div`
  width: ${props => !props?.width && '40px'};
  height: 40px;
  background: ${COLORS.WHITE};
  border: ${props =>
    !props?.isSelected ? `1px solid ${COLORS.GREY_T_90}` : '1px solid #adb6ef'};
  border-radius: 10px;
  padding: 8px 12px;
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  text-align: center;
  color: ${COLORS.GREY_T_60};
  cursor: pointer;
  color: ${props => props?.isSelected && '#999FAC'};
`
export const RowDiv = styled(Row)`
  width: 100%;
  padding: 15px;
`
export const SubTitleText = styled.div`
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  font-weight: 600;
  line-height: 15px;
  color: #4b465c;
  padding-top: 12px;
  padding-bottom: 12px;
  overflow: wrap;
`

export const FilterCollapse = styled(Collapse)`
  width: 100%;
  background-color: #dbdade !important;
  margin-right: 5px;

  .ant-collapse-header {
    position: relative;
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-start;
    padding: 10px !important;
    font-weight: 600;
    border-radius: 15px !important;
    border-radius: 10px;
    color: #4b465c !important;
    line-height: 1.5715;
    cursor: pointer;
    transition: all 0.3s, visibility 0s;
  }
  .ant-collapse-content > .ant-collapse-content-box {
    padding: 0px !important;
  }
  .ant-collapse-borderless
    > .ant-collapse-item
    > .ant-collapse-content
    > .ant-collapse-content-box {
    padding: 0px !important;
  }

  @media only screen and (max-device-width: 767px) {
    .ant-collapse-content > .ant-collapse-content-box {
      padding: 0px !important;
    }
  }
  @media only screen and (min-width: 768px) and (max-width: 1200px) {
    .ant-collapse-content > .ant-collapse-content-box {
      padding: 0px !important;
    }
  }
`

export const FeedBackDiv = styled.div`
  width: 100%;
  background: #f3f3f3;
  padding: 10px;
`

export const TitleText1 = styled.div`
  font-family: Plus Jakarta Sans;
  padding-top: 7px;
  font-size: 12px;
  font-weight: 400;
  line-height: 11px;
  color: #4b465c;
  span {
    font-weight: 600 !important;
  }
`

export const FeedBackText = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: #4b465c;
  padding-top: 8px;
`

export const FeedBackTextBox = styled(Input)`
  background: #f3f3f3;
  .ant-input {
    background-color: #f3f3f3;
  }
`
export const StyledSelect = styled(AntdSelect)`
  width: 100% !important;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #676e83;

  .ant-select-selector {
    background-color: ${props =>
      props?.disabled
        ? COLORS.DISABLED_SECONDARY
        : props.backgroundcolor
        ? props.backgroundcolor
        : '#ffffff'} !important;
    border-radius: 8px !important;
    border-color: #e9e9e9 !important;
    box-shadow: none !important;
  }
  .ant-select-selection-item {
    background-color: ${props =>
      props?.mode === 'multiple' ? '#ebecee' : 'transparent'};
    color: ${COLORS.GREY_P_100};
  }
  :hover {
    background-color: transparent;
  }
  .ant-select-dropdown-placement-bottomLeft {
    width: 1000px !important;
  }
  .ant-select-selection-item-remove {
    display: flex;
    align-items: center;
  }
`
export const HeaderText = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 13px;
  color: #343e59;
  padding: 15px;
`
export const InfoSection = styled(Flex)`
  gap: 1px;
  margin-left: 10px;
  flex-direction: column;
`

export const BoldFontHead = styled.div`
  padding-top: 15px;
  font-size: 14px;
  font-weight: 700;
  line-height: 11px;
  color: #4b465c;
`

export const SubTextTitle = styled.div`
  font-family: Plus Jakarta Sans;
  font-size: 12px;
  font-weight: 400;
  line-height: 11px;
  padding-top: ${props => (props?.padTop ? '15px' : '0px')};
`

export const LeftSideBox = styled.div`
  position: absolute;
  right: 20%;
  padding-top: 8px;
`

export const ParameterText = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: 11px;
  color: #4b465c;
`
